import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initTheme } from './theme'

// Aplica el tema (claro/oscuro/sistema) y escucha cambios del tema del dispositivo
// para actualizar la app en vivo. Se hace antes de renderizar.
initTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
